import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
  fromDate: Yup.date()
    .required("From date is required"),
  toDate: Yup.date()
    .required("To date is required")
    .min(Yup.ref("fromDate"), "To date must be after From date"),
});

export function CommissionDownloadForm() {
  return (
    <div className="container my-4">

      <div className="card p-3 shadow-sm" style={{ maxWidth: "500px" }}>
        <Formik
          initialValues={{ fromDate: "", toDate: "" }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            // Handle download (replace with real logic later)
            console.log("Downloading commissions:", values);
            alert(
              `Downloading commissions from ${values.fromDate} to ${values.toDate}`
            );
          }}
        >
          {() => (
            <Form>
              {/* From Date */}
              <div className="mb-3">
                <label className="form-label">From</label>
                <Field
                  type="date"
                  name="fromDate"
                  className="form-control"
                />
                <ErrorMessage
                  name="fromDate"
                  component="div"
                  className="text-danger small"
                />
              </div>

              {/* To Date */}
              <div className="mb-3">
                <label className="form-label">To</label>
                <Field
                  type="date"
                  name="toDate"
                  className="form-control"
                />
                <ErrorMessage
                  name="toDate"
                  component="div"
                  className="text-danger small"
                />
              </div>

              {/* Submit Button */}
              <div className="d-flex justify-content-end">
                <button type="submit" className="btn btn-outline-info">
                  Download
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

